import { FeedPostDto } from "@/api/posts/types";
import { Popover } from "@/app/(components)/Basic/Popover";
import useMe from "@/shared/hooks/useMe";
import { isEqual } from "@/shared/string";
import { useState } from "react";
import EditIcon from "@/assets/icons/edit.svg";
import TrashIcon from "@/assets/icons/trash.svg";
import { FeedEditModal } from "../Modals/FeedEdit";
import { Button } from "@/app/(components)/Basic/Button";
import usePostDelete from "../hooks/usePostDelete";
import { ConfirmModal } from "@/app/(components)/Basic/ConfirmModal";

export interface Props {
  feedPost: FeedPostDto;
  repost?: FeedPostDto;
}

export default function FeedOptions({ feedPost, repost }: Props) {
  const [isDeleteConfirm, setIsDeleteConfirm] = useState(false);
  const [isEditConfirm, setIsEditConfirm] = useState(false);

  const { me } = useMe();

  const onClose = () => {
    setIsDeleteConfirm(false);
  };

  const { deletePost, isLoading } = usePostDelete(feedPost, onClose);

  return (
    <>
      {me && feedPost.author && isEqual(me.id, feedPost.author.id) && (
        <Popover>
          <Button
            native
            startIcon={
              <EditIcon className="fill-black night:fill-white w-[18px]" />
            }
            onClick={() => setIsEditConfirm(true)}
            className="flex items-center w-full gap-x-3 px-5 py-2 hover:bg-secondary rounded-lg"
          >
            <span className="text-lg">Edit</span>
          </Button>
          <Button
            native
            startIcon={
              <TrashIcon className="fill-black night:fill-white w-6" />
            }
            onClick={() => setIsDeleteConfirm(true)}
            className="flex items-center w-full gap-x-3 px-4 py-2 hover:bg-secondary rounded-lg"
          >
            <span className="text-lg">Delete</span>
          </Button>
        </Popover>
      )}
      <ConfirmModal
        isOpen={isDeleteConfirm}
        onClose={onClose}
        onSubmit={deletePost}
        isLoading={isLoading}
        title="Delete post"
        text="Are you sure you want to delete this post?"
      />
      {isEditConfirm ? (
        <FeedEditModal
          feedPost={feedPost}
          repost={repost}
          onSuccess={() => setIsEditConfirm(false)}
          onClose={() => setIsEditConfirm(false)}
        />
      ) : null}
    </>
  );
}
